
import { mapState, mapGetters, mapMutations } from 'vuex'
import { analytics } from '~/plugins/firebase'
import { logEvent } from 'firebase/analytics'
import { arrayUnion } from 'firebase/firestore'
import { updateFirestoreDoc } from '../../api'

export default {
  props: {
    gradId: {
      type: String,
    },
  },
  data() {
    return {
      dialog: false,
      list: '',
      hex: '#f44336',
      loading: false,
    }
  },
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
  },
  methods: {
    ...mapMutations(['SHOW_MESSAGE']),
    async createList() {
      this.loading = true
      const ids = []
      if (this.gradId) {
        ids.push(this.gradId)
      }
      const [error] = await updateFirestoreDoc('users', this.authUser.uid, {
        likes: arrayUnion({
          name: this.list,
          ids: ids,
          hex: this.hex,
        }),
      })
      this.loading = false
      if (error) {
        this.SHOW_MESSAGE({ content: error.message, color: 'error' })
        return
      }
      this.list = ''
      this.dialog = false
      this.$emit('newList', { name: this.list, ids: ids, hex: this.hex })
      this.SHOW_MESSAGE({
        content: `${this.list} list created`,
        color: 'success',
      })
      logEvent(analytics, 'create_list', { list_name: this.list })
    },
  },
}
